import { gql } from '@apollo/client';

export const GET_FLASH_SENDER_HISTORIES = gql`
  query GetFlashSenderHistories(
    $where: FlashSenderHistoryWhereInput
    $orderBy: [FlashSenderHistoryOrderByInput!]
    $first: Int!
    $skip: Int
  ) {
    flashSenderHistories(
      where: $where
      orderBy: $orderBy
      first: $first
      skip: $skip
    ) {
      id
      createdAt
    }
  }
`;
